import ValidateObject from './validateData'
// import ValidateEmail from './ValidateEmail'
import ValidateEmail from './ValidateEmail-new'
// SOCKETS
'socket.io-client';

export default {
  data() {
    return {}
  },
  created() {
  },
  methods: {
    numberWithCommas(num) {
      if (typeof num === "number") {
        let nag = false;
        if (num < 0) {
          nag = true;
          num *= (-1);  
        }
        let numWithCommas = num.toString();
        if (num % 1 > 0) {
          numWithCommas = num.toFixed(2);
        }
        numWithCommas = numWithCommas.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return nag ? `${numWithCommas}-` : numWithCommas;
      } else {
        return num;
      }
    },
    validateObject: ValidateObject,
    validateEmail: ValidateEmail
  }
}



// WEBPACK FOOTER //
// ./src/Helpers/index.js